var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _g2, _path11, _path12, _g3, _path13, _path14, _g4, _path15, _path16, _g5, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g6, _path24, _path25, _g7, _path26, _path27, _g8, _path28, _path29, _g9, _path30, _path31, _g10, _path32, _path33, _g11, _path34, _path35, _g12, _path36, _path37, _g13, _path38, _path39, _g14, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _g15, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _g16, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreate2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 471,
    height: 410,
    viewBox: "0 0 471 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5176 405.643H470",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37793 405.643H15.342",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.347 52.0149H30.5771V193.877H118.347V52.0149Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.481 69.5833H41.4434V176.319H107.481V69.5833Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M440.188 52.0149H352.419V193.877H440.188V52.0149Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M429.323 69.5833H363.285V176.319H429.323V69.5833Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.698 123.275H146.33V164.826H154.698V123.275Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_880_3187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 123,
    width: 9,
    height: 42
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M154.697 123.275H146.329V164.826H154.697V123.275Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_880_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.84 128.148H145.889V129.978H155.84V128.148Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.84 158.422H145.889V160.252H155.84V158.422Z",
    fill: "#92E3A9"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M164.043 123.275H155.675V164.826H164.043V123.275Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_880_3187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 155,
    y: 123,
    width: 10,
    height: 42
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M164.042 123.275H155.674V164.826H164.042V123.275Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_880_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.184 128.148H155.233V129.978H165.184V128.148Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.184 158.422H155.233V160.252H165.184V158.422Z",
    fill: "#92E3A9"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M317.378 164.919V156.551H275.827V164.919H317.378Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_880_3187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 275,
    y: 156,
    width: 43,
    height: 9
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M317.378 164.919V156.551H275.827V164.919H317.378Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_880_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.494 166.05V156.099H310.664V166.05H312.494Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.22 166.05V156.099H280.39V166.05H282.22Z",
    fill: "#92E3A9"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M317.368 156.438V148.07H275.817V156.438H317.368Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_880_3187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 275,
    y: 148,
    width: 43,
    height: 9
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M317.368 156.438V148.07H275.817V156.438H317.368Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_880_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.494 157.569V147.618H310.664V157.569H312.494Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.231 157.569V147.618H280.402V157.569H282.231Z",
    fill: "#92E3A9"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.778 122.932L163.769 125.354L175.792 165.127L183.802 162.706L171.778 122.932Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_880_3187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 122,
    width: 21,
    height: 44
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M171.78 122.932L163.771 125.354L175.794 165.127L183.804 162.706L171.78 122.932Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_880_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.288 127.278L164.763 130.157L165.292 131.909L174.817 129.03L174.288 127.278Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.04 156.248L173.515 159.128L174.044 160.879L183.569 158L183.04 156.248Z",
    fill: "#92E3A9"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M232.734 151.514C232.734 151.514 226.227 143.794 227.45 140.751C228.673 137.708 230.534 141.357 230.534 141.357C230.534 141.357 225.055 129.022 230.133 128.353C235.211 127.685 237.648 137.903 237.648 137.903C237.648 137.903 239.477 127.336 242.726 130.79C245.974 134.244 242.119 143.187 242.119 143.187C242.119 143.187 248.822 137.903 247.198 142.375C245.573 146.847 238.861 152.12 238.861 152.12L232.734 151.514Z",
    fill: "#92E3A9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M233.564 151.73C233.564 151.73 224.827 144.616 228.281 142.992C231.735 141.368 233.76 144.822 233.76 144.822C233.76 144.822 231.704 132.424 235.59 132.424C239.475 132.424 238.674 142.18 238.674 142.18C238.674 142.18 240.904 134.459 242.94 137.307C244.975 140.155 240.092 152.542 240.092 152.542",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M243.496 149.684H228.261L229.782 164.518H241.974L243.496 149.684Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M182.71 90.811H166.869V107.999H182.71V90.811Z",
    fill: "#92E3A9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M178.692 75.7717H170.899V92.9597H178.692V75.7717Z",
    fill: "#92E3A9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M154.698 66.7358H146.33V108.287H154.698V66.7358Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_880_3187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 66,
    width: 9,
    height: 43
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M154.697 66.7358H146.329V108.287H154.697V66.7358Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_880_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.84 71.6084H145.889V73.4382H155.84V71.6084Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.84 101.883H145.889V103.712H155.84V101.883Z",
    fill: "#92E3A9"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M326.406 67.0057L318.168 65.5354L310.867 106.44L319.105 107.91L326.406 67.0057Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_880_3187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 310,
    y: 65,
    width: 17,
    height: 43
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M326.405 67.0057L318.167 65.5354L310.866 106.44L319.104 107.91L326.405 67.0057Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_880_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.682 72.0085L316.886 70.26L316.564 72.0614L326.36 73.8098L326.682 72.0085Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.353 101.809L311.557 100.06L311.235 101.861L321.031 103.61L321.353 101.809Z",
    fill: "#92E3A9"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M164.043 66.7358H155.675V108.287H164.043V66.7358Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_880_3187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 155,
    y: 66,
    width: 10,
    height: 43
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M164.042 66.7358H155.674V108.287H164.042V66.7358Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_880_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.184 71.6084H155.233V73.4382H165.184V71.6084Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.184 101.883H155.233V103.712H165.184V101.883Z",
    fill: "#92E3A9"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M215.699 66.7358H207.331V108.287H215.699V66.7358Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_880_3187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 207,
    y: 66,
    width: 9,
    height: 43
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M215.701 66.7358H207.333V108.287H215.701V66.7358Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_880_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.83 71.6084H206.879V73.4382H216.83V71.6084Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.83 101.883H206.879V103.712H216.83V101.883Z",
    fill: "#92E3A9"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M224.149 66.7358H215.781V108.287H224.149V66.7358Z",
    fill: "#6B6B6B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_880_3187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 215,
    y: 66,
    width: 10,
    height: 43
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M224.151 66.7358H215.783V108.287H224.151V66.7358Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_880_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.281 71.6084H215.33V73.4382H225.281V71.6084Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.281 101.883H215.33V103.712H225.281V101.883Z",
    fill: "#92E3A9"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M232.599 66.7358H224.231V108.287H232.599V66.7358Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_880_3187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 66,
    width: 9,
    height: 43
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M232.6 66.7358H224.232V108.287H232.6V66.7358Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_880_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.73 71.6084H223.779V73.4382H233.73V71.6084Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.73 101.883H223.779V103.712H233.73V101.883Z",
    fill: "#92E3A9"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M241.048 66.7358H232.681V108.287H241.048V66.7358Z",
    fill: "#6B6B6B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_880_3187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 232,
    y: 66,
    width: 10,
    height: 43
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M241.05 66.7358H232.683V108.287H241.05V66.7358Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_880_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.181 71.6086H232.23V73.4385H242.181V71.6086Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.181 101.883H232.23V103.713H242.181V101.883Z",
    fill: "#92E3A9"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M249.499 66.7358H241.131V108.287H249.499V66.7358Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_880_3187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 241,
    y: 66,
    width: 9,
    height: 43
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M249.501 66.7358H241.133V108.287H249.501V66.7358Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_880_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.63 71.6084H240.679V73.4382H250.63V71.6084Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.63 101.883H240.679V103.712H250.63V101.883Z",
    fill: "#92E3A9"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M310.716 108.369V100.001H269.165V108.369H310.716Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_880_3187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 269,
    y: 100,
    width: 42,
    height: 9
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M310.714 108.369V100.001H269.163V108.369H310.714Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_880_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.833 109.51V99.5593H304.003V109.51H305.833Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.567 109.51V99.5593H273.738V109.51H275.567Z",
    fill: "#92E3A9"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M139.844 51.6758V169.391H331.224V51.6758H139.844ZM264.168 56.127V108.215H206.838V56.127H264.168ZM144.727 56.127H202.006V108.215H144.727V56.127ZM144.727 164.95V112.851H202.006V164.95H144.727ZM206.879 164.95V112.851H264.168V164.95H206.879ZM326.331 164.95H269.041V112.851H326.331V164.95ZM269.041 108.215V56.127H326.331V108.215H269.041Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M188.384 334.999H171.483V405.643H188.384V334.999Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M299.559 334.999H282.659V405.643H299.559V334.999Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M299.571 327.526H171.483V338.587H299.571V327.526Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M226.625 314.285C225.05 311.79 223.334 309.388 221.485 307.089C218.915 304.005 211.719 298.094 211.719 298.094L220.971 302.977C220.971 302.977 219.429 298.608 217.887 295.01C216.345 291.412 213.775 282.675 213.775 282.675C213.775 282.675 219.943 293.211 221.485 295.01C223.027 296.809 225.597 300.664 225.597 300.664C225.597 300.664 225.854 290.898 227.139 287.815C228.424 284.731 233.82 277.535 233.82 277.535C233.82 277.535 232.021 288.843 232.021 290.128C232.021 291.412 232.792 299.379 232.792 299.379L235.876 283.189L236.133 294.496L238.446 282.418C238.446 282.418 240.245 291.669 240.759 294.496C241.091 296.622 241.263 298.77 241.273 300.921L243.586 292.44L249.24 282.675C249.24 282.675 249.24 293.725 248.983 294.753C248.726 295.781 248.469 302.463 248.469 302.463L251.81 298.865L249.24 306.832L252.581 307.346L254.123 308.631C254.123 308.631 247.955 310.471 245.241 311.222C242.528 311.972 237.418 315.056 237.418 315.056L226.625 314.285Z",
    fill: "#92E3A9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M228.423 314.285C228.423 314.285 224.054 304.776 219.685 302.463C215.316 300.15 213.26 299.122 213.26 299.122C213.26 299.122 219.685 299.379 223.026 301.692C225.158 303.255 226.914 305.275 228.166 307.603C227.486 304.392 227.142 301.12 227.138 297.838C227.138 292.441 228.423 280.876 228.423 280.876C228.423 280.876 228.166 295.268 229.451 300.15C230.362 303.422 231.566 306.604 233.049 309.659C233.049 309.659 233.563 305.033 234.333 300.407C235.296 295.892 236.497 291.432 237.931 287.044L235.875 305.547C237.254 303.243 238.457 300.837 239.473 298.352C241.015 294.497 248.725 289.357 248.725 289.357C248.725 289.357 242.814 296.81 241.529 300.921C240.244 305.033 238.959 308.631 238.959 308.631C240.382 306.426 242.113 304.435 244.099 302.72C247.183 300.15 252.837 298.609 252.837 298.609C252.837 298.609 245.127 304.262 244.356 306.061C243.585 307.86 242.3 311.201 242.3 311.201C242.3 311.201 249.496 305.033 255.664 303.234C255.664 303.234 246.155 309.916 243.585 314.542L228.423 314.285Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M223.058 312.25C222.635 313.753 222.41 315.304 222.39 316.865C222.39 326.282 228.002 327.063 234.921 327.063C241.839 327.063 247.452 326.539 247.452 316.865C247.432 315.304 247.207 313.753 246.784 312.25H223.058Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M222.39 316.866C222.39 317.071 222.39 317.256 222.39 317.462H247.411C247.411 317.256 247.411 317.071 247.411 316.866C247.411 316.444 247.411 316.012 247.349 315.57H222.451C222.41 315.995 222.39 316.427 222.39 316.866Z",
    fill: "#92E3A9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M247.226 319.837C247.226 319.549 247.308 319.24 247.339 318.922H222.503C222.503 319.24 222.575 319.549 222.626 319.837H247.226Z",
    fill: "#92E3A9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M439.335 334.516L445.123 405.19H443.098L432.674 335.102L439.335 334.516Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M395.903 334.516L401.69 405.19H399.665L389.241 335.102L395.903 334.516Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M390.69 334.516L384.893 405.19H386.928L397.352 335.102L390.69 334.516Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M341.461 334.516L335.674 405.19H337.699L348.123 335.102L341.461 334.516Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M394.433 221.694H458.692C458.692 221.694 466.402 223.833 462.979 232.838C459.556 241.843 440.291 336.973 440.291 336.973H338.295L331.87 277.833C331.87 277.833 330.574 269.259 336.578 267.974C342.581 266.689 367.006 267.543 371.725 264.973C376.443 262.403 387.062 225.118 387.062 225.118C387.062 225.118 387.998 220.821 394.433 221.694Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M389.54 323.506H338.264",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M427.524 147.34C423.256 144.101 418.197 142.066 412.875 141.45C404.6 140.74 392.552 150.702 392.315 156.099C392.079 161.496 389.015 160.591 388.07 163.665C387.124 166.738 390.897 166.255 390.897 168.383C390.897 170.511 385.942 173.112 386.415 175.003C386.888 176.895 392.079 178.786 392.079 179.958C392.079 181.13 389.242 183.268 391.606 185.16C393.97 187.051 396.335 185.633 397.28 187.997C398.226 190.361 400.364 192.726 401.063 191.081C401.762 189.436 399.408 179.773 400.354 172.886C401.3 165.998 403.191 162.966 410.511 160.128C417.83 157.291 423.032 155.163 426.105 152.326C429.179 149.489 427.524 147.34 427.524 147.34Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_880_3187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 386,
    y: 141,
    width: 42,
    height: 51
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M427.523 147.34C423.255 144.1 418.196 142.066 412.874 141.45C404.599 140.74 392.551 150.701 392.314 156.098C392.078 161.495 389.014 160.591 388.069 163.664C387.123 166.738 390.896 166.255 390.896 168.383C390.896 170.511 385.941 173.112 386.414 175.003C386.887 176.895 392.078 178.786 392.078 179.958C392.078 181.13 389.241 183.268 391.605 185.16C393.969 187.051 396.334 185.632 397.279 187.997C398.225 190.361 400.363 192.726 401.062 191.081C401.761 189.436 399.407 179.773 400.353 172.885C401.299 165.998 403.19 162.965 410.51 160.128C417.829 157.291 423.031 155.163 426.104 152.326C429.178 149.488 427.523 147.34 427.523 147.34Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_880_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.398 148.255C417.398 148.255 411.23 143.834 406.789 147.659C402.348 151.483 402.677 156.201 399.419 157.681C396.16 159.162 391.462 160.035 393.251 164.158C395.039 168.28 398.267 174.438 394.731 175.651C391.195 176.864 388.563 180.071 389.714 181.253",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M427.524 147.34C423.256 144.101 418.197 142.066 412.875 141.45C404.6 140.74 392.552 150.702 392.315 156.099C392.079 161.496 389.015 160.591 388.07 163.665C387.124 166.738 390.897 166.255 390.897 168.383C390.897 170.511 385.942 173.112 386.415 175.003C386.888 176.895 392.079 178.786 392.079 179.958C392.079 181.13 389.242 183.268 391.606 185.16C393.97 187.051 396.335 185.633 397.28 187.997C398.226 190.361 400.364 192.726 401.063 191.081C401.762 189.436 399.408 179.773 400.354 172.886C401.3 165.998 403.191 162.966 410.511 160.128C417.83 157.291 423.032 155.163 426.105 152.326C429.179 149.489 427.524 147.34 427.524 147.34Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M412.433 152.295C412.433 152.295 400.622 157.733 398.967 162.225C397.312 166.718 398.494 174.746 398.021 175.928C397.548 177.11 393.765 179.238 394.238 180.174C394.991 181.219 395.863 182.171 396.839 183.011C396.839 183.011 397.312 195.296 400.385 196.241C403.459 197.187 411.693 194.597 411.693 194.597L416.658 212.782L436.972 207.117L429.416 189.868C429.416 189.868 438.668 177.82 439.572 169.781C440.477 161.742 432.489 150.876 426.579 149.694C420.668 148.512 413.348 151.822 413.348 151.822L412.433 152.295Z",
    fill: "#B2B2B2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M402.359 176.628C402.943 176.628 403.417 175.624 403.417 174.387C403.417 173.149 402.943 172.146 402.359 172.146C401.774 172.146 401.3 173.149 401.3 174.387C401.3 175.624 401.774 176.628 402.359 176.628Z",
    fill: "#263238"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M400.827 167.89C400.827 167.89 403.428 164.806 406.255 168.362",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M388.254 268.313C388.254 268.313 367.859 272.724 364.703 273.145C361.547 273.566 358.186 272.312 357.343 272.117C356.5 271.922 349.777 268.54 348.934 268.54C348.091 268.54 345.572 270.647 342.838 271.274C340.104 271.901 336.536 270.647 335.899 271.911C335.262 273.176 338.212 273.587 339.682 273.803C341.152 274.019 344.524 274.009 344.524 274.009C344.524 274.009 339.055 277.164 338.212 277.586C337.369 278.007 331.695 276.321 332.116 278.213C332.538 280.104 340.946 281.163 344.524 281.575C348.101 281.986 357.343 278.85 357.343 278.85C357.343 278.85 369.535 281.574 374.819 281.369C380.103 281.163 387.216 280.742 387.216 280.742L388.254 268.313Z",
    fill: "#B2B2B2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M341.367 280.927C341.367 280.927 332.958 277.565 334.644 277.565C336.33 277.565 340.524 279.457 340.524 279.457C340.524 279.457 337.368 276.517 338.468 276.517C339.568 276.517 345.613 279.2 345.613 279.2C345.613 279.2 341.614 276.887 343.927 277.308C346.24 277.73 351.123 279.2 351.123 279.2",
    fill: "#B2B2B2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M341.367 280.927C341.367 280.927 332.958 277.565 334.644 277.565C336.33 277.565 340.524 279.457 340.524 279.457C340.524 279.457 337.368 276.517 338.468 276.517C339.568 276.517 345.613 279.2 345.613 279.2C345.613 279.2 341.614 276.887 343.927 277.308C346.24 277.73 351.123 279.2 351.123 279.2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M321.621 279.807C321.621 279.807 307.229 279.807 304.042 287.887C300.855 295.967 326.658 388.691 326.658 388.691C326.658 388.691 317.519 398.878 311.187 401.346C304.854 403.813 303.806 404.512 306.263 405.211C308.72 405.91 320.325 406.239 326.308 404.512C332.291 402.785 340.371 398.179 343.537 396.771C346.704 395.363 342.129 392.556 340.022 387.283C337.914 382.009 330.04 349.771 329.69 339.574C329.341 329.376 325.815 301.25 325.815 301.25C325.815 301.25 337.071 309.341 358.166 313.206C379.26 317.071 358.875 291.053 349.376 285.08C339.878 279.108 321.621 279.807 321.621 279.807Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M330.194 393.605L326.082 389.297C324.026 391.497 316.573 399.238 311.166 401.345C304.834 403.802 303.785 404.512 306.242 405.211C308.699 405.91 320.305 406.239 326.288 404.512C332.271 402.785 340.351 398.179 343.517 396.771C346.488 395.455 342.643 392.895 340.433 388.228L330.194 393.605Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M305.943 403.586C304.617 404.357 304.843 404.768 306.282 405.18C308.749 405.889 320.345 406.208 326.328 404.481C332.31 402.754 340.39 398.148 343.557 396.74C345.006 396.092 344.821 395.146 343.999 393.81C336.998 397.1 322.277 403.905 319.718 404.244C316.603 404.686 307.423 403.771 305.943 403.586Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M435.551 204.28L411.692 211.127C411.692 211.127 409.564 219.875 403.19 224.604C396.817 229.332 388.799 233.855 386.886 241.843C384.974 249.83 385.468 257.437 385.941 264.531C386.414 271.624 380.739 286.499 380.739 286.499C380.739 286.499 344.585 278.707 332.537 279.2C320.489 279.693 311.751 278.018 309.859 290.066C307.968 302.114 316.027 385.442 316.027 385.442C316.027 385.442 303.743 396.75 298.305 400.101C292.867 403.453 288.385 405.529 291.458 406.711C294.532 407.894 309.89 406.239 315.554 405.293C321.219 404.347 331.149 403.874 332.568 400.564C333.986 397.254 329.021 381.906 329.258 380.488C329.494 379.069 329.946 345.824 332.074 333.776C333.488 325.012 334.435 316.18 334.911 307.315C334.911 307.315 387.606 321.964 400.6 321.964C413.594 321.964 422.095 320.073 425.878 298.321C429.661 276.568 426.587 273.505 431.08 264.767C435.572 256.029 439.818 245.153 440.332 231.686C440.846 218.22 435.551 204.28 435.551 204.28Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M394.052 299.143C385.91 292.554 382.466 288.277 381.058 285.635C380.862 286.19 380.739 286.499 380.739 286.499C380.739 286.499 344.585 278.707 332.537 279.2C320.489 279.693 311.751 278.018 309.859 290.066C307.968 302.114 316.027 385.442 316.027 385.442C316.027 385.442 303.743 396.75 298.305 400.102C292.867 403.453 288.385 405.529 291.458 406.711C294.532 407.894 309.89 406.239 315.554 405.293C321.219 404.347 331.149 403.874 332.568 400.564C333.986 397.254 329.021 381.906 329.258 380.488C329.494 379.069 329.946 345.824 332.074 333.776C333.488 325.012 334.435 316.18 334.911 307.315C334.911 307.315 387.606 321.964 400.6 321.964C410.119 321.964 417.233 320.936 421.838 311.839C413.522 309.865 402.717 306.154 394.052 299.143Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M315.206 386.172C312.379 388.742 302.87 397.275 298.296 400.081C292.868 403.381 288.376 405.509 291.449 406.691C294.523 407.873 309.881 406.218 315.545 405.272C321.21 404.327 331.14 403.854 332.559 400.544C333.402 398.58 331.983 392.32 330.749 387.303L318.948 391.148L315.206 386.172Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M291.449 406.67C294.533 407.853 309.88 406.198 315.545 405.252C321.209 404.306 331.139 403.833 332.558 400.523C332.621 400.374 332.669 400.219 332.702 400.061C321.096 402.466 301.05 404.172 290.811 404.954C290.215 405.642 290.307 406.259 291.449 406.67Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M411.693 211.127C411.693 211.127 409.565 219.875 403.191 224.604C396.818 229.332 388.799 233.855 386.887 241.843C384.975 249.83 385.469 257.437 385.942 264.531C386.415 271.624 380.74 286.499 380.74 286.499C380.74 286.499 376.381 285.563 370.183 284.35C371.642 293.52 378.293 319.723 406.563 321.717C416.216 320.803 422.702 316.526 425.869 298.321C429.652 276.579 426.578 273.505 431.07 264.767C435.563 256.029 439.808 245.153 440.322 231.686C440.836 218.22 435.593 204.28 435.593 204.28L411.693 211.127Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M409.565 217.274L436.972 209.945",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M352.368 247.507C352.368 247.507 351.247 240.383 349.942 241.401C348.636 242.418 350.24 248.741 350.24 248.741C350.972 248.996 351.737 249.145 352.512 249.183",
    fill: "#B2B2B2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M352.368 247.507C352.368 247.507 351.247 240.383 349.942 241.401C348.636 242.418 350.24 248.741 350.24 248.741C350.972 248.996 351.737 249.145 352.512 249.183",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M435.788 222.476C435.788 222.476 434.37 215.619 425.632 216.801C416.894 217.983 413.82 222.239 411.456 233.814C409.091 245.389 405.545 264.294 405.545 264.294C405.545 264.294 375.301 245.389 370.819 242.316C366.337 239.242 360.653 238.779 358.062 240.661C355.471 242.542 348.368 249.409 348.368 249.409C348.368 249.409 344.822 242.316 344.349 244.68C343.876 247.044 345.531 253.192 349.077 254.61C352.624 256.029 358.987 251.126 359.697 250.889C360.406 250.653 355.441 255.854 357.096 256.091C358.751 256.327 360.18 254.199 363.264 252.308C365.304 250.982 367.143 249.369 368.722 247.517C368.722 247.517 385.499 263.585 390.69 267.604C395.882 271.624 410.037 282.284 412.874 282.284C415.712 282.284 419.484 277.792 421.376 273.772C423.267 269.753 434.842 243.96 436.497 231.481",
    fill: "#B2B2B2"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M435.788 222.476C435.788 222.476 434.37 215.619 425.632 216.801C416.894 217.983 413.82 222.239 411.456 233.814C409.091 245.389 405.545 264.294 405.545 264.294C405.545 264.294 375.301 245.389 370.819 242.316C366.337 239.242 360.653 238.779 358.062 240.661C355.471 242.542 348.368 249.409 348.368 249.409C348.368 249.409 344.822 242.316 344.349 244.68C343.876 247.044 345.531 253.192 349.077 254.61C352.624 256.029 358.987 251.126 359.697 250.889C360.406 250.653 355.441 255.854 357.096 256.091C358.751 256.327 360.18 254.199 363.264 252.308C365.304 250.982 367.143 249.369 368.722 247.517C368.722 247.517 385.499 263.585 390.69 267.604C395.882 271.624 410.037 282.284 412.874 282.284C415.712 282.284 419.484 277.792 421.376 273.772C423.267 269.753 434.842 243.96 436.497 231.481",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M359.698 250.889L360.726 248.977C360.286 248.115 359.908 247.221 359.596 246.304C359.547 245.9 359.594 245.49 359.731 245.106C359.869 244.723 360.093 244.376 360.387 244.094",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M359.698 250.889L360.726 248.977C360.286 248.115 359.908 247.221 359.596 246.304C359.547 245.9 359.594 245.49 359.731 245.106C359.869 244.723 360.093 244.376 360.387 244.094",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M350.003 251.27C350.003 251.27 342.324 243.909 341.707 246.253C341.09 248.597 348.605 254.611 348.605 254.611C349.215 254.739 349.85 254.658 350.409 254.382C350.969 254.107 351.419 253.651 351.689 253.089",
    fill: "#B2B2B2"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M350.003 251.27C350.003 251.27 342.324 243.909 341.707 246.253C341.09 248.597 348.605 254.611 348.605 254.611C349.215 254.739 349.85 254.658 350.409 254.382C350.969 254.107 351.419 253.651 351.689 253.089",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M353.128 251.609C353.128 251.609 349.53 241.606 347.937 243.385C346.343 245.163 350.394 253.932 350.394 253.932C350.394 253.932 350.969 256.06 355.225 253.151",
    fill: "#B2B2B2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M353.128 251.609C353.128 251.609 349.53 241.606 347.937 243.385C346.343 245.163 350.394 253.932 350.394 253.932C350.394 253.932 350.969 256.06 355.225 253.151",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M454.673 266.916C454.673 266.916 438.904 280.125 419.968 281.441C401.032 282.757 392.778 286.242 391.575 296.686C390.372 307.13 388.943 336.654 388.943 336.654L439.952 336.973L451.784 280.917L454.673 266.916Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M441.843 281.965C441.843 281.965 437.115 288.277 425.282 289.326C413.45 290.374 404.507 291.957 401.639 295.905",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M460.543 190.526C458.374 189.899 461.787 185.869 463.34 182.148C464.892 178.426 460.543 176.247 457.172 174.387C453.8 172.526 457.172 168.794 456.863 163.829C456.555 158.864 452.751 158.956 450.963 156.078C449.174 153.2 452.515 143.66 440.415 142.416C428.316 141.172 423.659 143.043 418.684 145.5C416.288 146.791 414.318 148.748 413.009 151.133C411.868 152.213 410.953 153.57 411.498 154.875C412.68 157.713 413.863 159.604 412.207 162.678C410.552 165.751 411.498 168.578 412.917 169.761C414.335 170.943 414.335 174.016 411.971 176.381C409.607 178.745 410.316 180.626 412.444 181.809C414.572 182.991 416.936 186.064 414.808 188.902C412.68 191.739 413.39 195.748 417.646 196.694C419.004 196.914 420.339 197.259 421.634 197.722L422.662 202.255C422.364 204.219 421.994 206.007 423.567 206.367C424.233 206.455 424.909 206.329 425.499 206.007C426.251 205.855 426.99 205.645 427.709 205.38C429.262 204.753 429.879 208.464 431.431 211.548C432.983 214.632 437.599 213.1 440.128 210.921C440.38 210.686 440.682 210.511 441.011 210.41C441.341 210.308 441.689 210.283 442.029 210.335C442.946 211.043 444.051 211.465 445.206 211.548C446.699 212.32 448.385 212.642 450.058 212.473C454.715 211.857 454.088 209.996 454.715 207.2C455.342 204.404 457.799 204.404 461.541 201.299C465.282 198.195 462.712 191.143 460.543 190.526Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_880_3187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 410,
    y: 142,
    width: 54,
    height: 72
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M460.541 190.526C458.372 189.899 461.785 185.869 463.338 182.148C464.89 178.426 460.541 176.247 457.17 174.386C453.798 172.526 457.17 168.794 456.861 163.829C456.553 158.864 452.749 158.956 450.961 156.078C449.172 153.199 452.513 143.66 440.413 142.416C428.314 141.172 423.657 143.043 418.682 145.5C416.286 146.791 414.316 148.747 413.007 151.133C411.866 152.213 410.951 153.57 411.496 154.875C412.678 157.712 413.861 159.604 412.206 162.677C410.55 165.751 411.496 168.578 412.915 169.76C414.333 170.943 414.333 174.016 411.969 176.381C409.605 178.745 410.314 180.626 412.442 181.808C414.57 182.991 416.934 186.064 414.806 188.901C412.678 191.739 413.388 195.748 417.644 196.694C419.002 196.914 420.337 197.258 421.632 197.722L422.66 202.255C422.362 204.218 421.992 206.007 423.565 206.367C424.231 206.454 424.907 206.328 425.497 206.007C426.249 205.855 426.988 205.645 427.708 205.38C429.26 204.753 429.877 208.464 431.429 211.548C432.981 214.632 437.597 213.1 440.126 210.921C440.378 210.686 440.68 210.511 441.009 210.41C441.339 210.308 441.687 210.283 442.027 210.335C442.944 211.043 444.049 211.465 445.204 211.548C446.697 212.32 448.383 212.641 450.056 212.473C454.713 211.856 454.086 209.996 454.713 207.2C455.34 204.403 457.797 204.403 461.539 201.299C465.28 198.194 462.71 191.142 460.541 190.526Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_880_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.686 146.775C417.686 146.775 420.338 148.255 419.166 152.665C417.994 157.075 415.918 159.152 417.984 160.622C420.05 162.092 425.345 165.042 424.152 168.846C422.96 172.649 419.146 176.206 422.384 178.57C425.622 180.935 432.397 182.394 432.109 187.113C431.821 191.831 429.744 195.337 432.397 196.838C435.049 198.338 439.181 195.655 439.767 198.894C440.353 202.132 438.585 206.552 440.651 207.117C442.718 207.683 445.894 206.501 446.819 208.588C447.379 209.881 447.581 211.301 447.405 212.699",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.288 142.95C423.288 142.95 429.456 144.719 429.178 149.725C428.901 154.731 426.526 162.061 428.593 163.274C430.659 164.487 436.251 166.224 435.665 170.058C435.079 173.893 433.013 177.121 434.781 178.601C436.549 180.081 441.843 182.713 441.843 185.077C441.843 187.442 438.903 187.442 440.959 190.68C443.015 193.918 449.512 193.62 449.8 198.04C450.088 202.461 448.33 204.825 449.214 205.709C450.098 206.593 452.452 209.235 453.326 209.533C454.2 209.831 453.624 213.953 453.624 213.953",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.13 138.818C432.13 138.818 441.258 143.834 440.672 149.725C440.086 155.615 439.202 158.565 440.672 160.005C442.142 161.444 445.381 163.541 445.381 166.491",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.563 174.181C446.563 174.181 445.977 179.485 448.331 180.657C450.685 181.829 456.288 187.73 456.288 190.937C456.288 194.144 454.519 197.423 456.586 199.778C458.688 201.916 460.953 203.889 463.36 205.678",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M460.543 190.526C458.374 189.899 461.787 185.869 463.34 182.148C464.892 178.426 460.543 176.247 457.172 174.387C453.8 172.526 457.172 168.794 456.863 163.829C456.555 158.864 452.751 158.956 450.963 156.078C449.174 153.2 452.515 143.66 440.415 142.416C428.316 141.172 423.659 143.043 418.684 145.5C416.288 146.791 414.318 148.748 413.009 151.133C411.868 152.213 410.953 153.57 411.498 154.875C412.68 157.713 413.863 159.604 412.207 162.678C410.552 165.751 411.498 168.578 412.917 169.761C414.335 170.943 414.335 174.016 411.971 176.381C409.607 178.745 410.316 180.626 412.444 181.809C414.572 182.991 416.936 186.064 414.808 188.902C412.68 191.739 413.39 195.748 417.646 196.694C419.004 196.914 420.339 197.259 421.634 197.722L422.662 202.255C422.364 204.219 421.994 206.007 423.567 206.367C424.233 206.455 424.909 206.329 425.499 206.007C426.251 205.855 426.99 205.645 427.709 205.38C429.262 204.753 429.879 208.464 431.431 211.548C432.983 214.632 437.599 213.1 440.128 210.921C440.38 210.686 440.682 210.511 441.011 210.41C441.341 210.308 441.689 210.283 442.029 210.335C442.946 211.043 444.051 211.465 445.206 211.548C446.699 212.32 448.385 212.642 450.058 212.473C454.715 211.857 454.088 209.996 454.715 207.2C455.342 204.404 457.799 204.404 461.541 201.299C465.282 198.195 462.712 191.143 460.543 190.526Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M31.248 334.516L25.4502 405.19H27.4753L37.8991 335.102L31.248 334.516Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6797 334.516L68.8818 405.19H70.907L81.3308 335.102L74.6797 334.516Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8815 334.516L85.6794 405.19H83.6543L73.2305 335.102L79.8815 334.516Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M129.113 334.516L134.9 405.19H132.875L122.451 335.102L129.113 334.516Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1394 221.695H11.8593C11.8593 221.695 4.14944 223.833 7.57263 232.838C10.9958 241.843 30.2911 336.973 30.2911 336.973H132.278L138.713 277.833C138.713 277.833 139.998 269.26 133.994 267.975C127.991 266.69 103.566 267.543 98.8579 264.973C94.1497 262.403 83.4792 225.118 83.4792 225.118C83.4792 225.118 82.5746 220.821 76.1394 221.695Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0439 323.506H132.32",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6198 168.804C48.6198 168.804 49.5553 205.288 49.9665 208.567C50.2067 211.273 49.8659 213.999 48.9671 216.563C48.0682 219.126 46.632 221.468 44.7546 223.432C39.738 228.839 19.4661 224.778 18.1194 219.762C16.7728 214.745 19.2708 206.398 19.2708 206.398C19.2708 206.398 11.5197 204.712 13.6785 197.989C15.8373 191.266 27.5769 179.269 32.9841 175.219C38.3913 171.169 44.5592 167.838 48.6198 168.804Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4755 176.473C34.4755 176.473 22.4275 197.424 20.5977 202.923",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4992 175.425C40.4992 175.425 27.1353 202.923 24.7812 214.19",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0239 185.9C41.0239 185.9 35.6783 201.073 34.4756 206.861",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M66.189 214.55C66.189 214.55 75.8931 214.303 80.1285 212.062C84.3638 209.821 93.0708 211.559 96.052 220.523C99.0331 229.487 104.769 245.914 107.01 252.637C109.251 259.36 114.473 265.579 114.473 265.579L93.811 273.536L81.8658 278.768C81.8658 278.768 72.4083 240.939 69.1701 231.224C65.932 221.51 64.9759 215.794 66.189 214.55Z",
    fill: "#787878",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M150.904 342.493L158.871 359.095L160.896 358.129L155.561 343.573L150.904 342.493Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M153.578 308.909C153.578 308.909 163.755 333.015 165.913 335.277C168.072 337.538 179.925 343.192 181.703 343.439C183.482 343.686 187.594 343.645 187.244 344.642C186.895 345.639 169.152 355.261 166.047 353.986C162.942 352.711 162.058 349.936 158.748 348.209C155.438 346.482 150.853 344.159 148.808 339.892C146.762 335.626 150.165 331.792 150.165 331.792L140.861 315.272L153.578 308.909Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M181.735 343.439C181.122 343.296 180.523 343.096 179.947 342.843C176.688 345.927 169.841 348.949 161.299 343.254C156.847 340.372 152.887 336.793 149.57 332.655C148.842 333.692 148.392 334.898 148.264 336.158C148.136 337.418 148.335 338.69 148.84 339.851C150.896 344.117 155.47 346.441 158.78 348.168C162.09 349.895 162.985 352.67 166.079 353.945C169.173 355.22 186.927 345.598 187.276 344.6C187.626 343.603 183.503 343.696 181.735 343.439Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M139.155 263.626C139.155 263.626 154.051 297.704 157.495 304.653L162.47 314.604L143.555 324.072C143.555 324.072 122.893 284.741 122.893 279.015C122.893 273.289 126.748 267.337 129.235 264.356C131.723 261.375 139.155 263.626 139.155 263.626Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M133.851 356.423C133.851 356.423 132.607 382.554 133.594 385.545C134.581 388.537 142.846 398.735 144.305 399.732C145.765 400.729 149.528 402.466 148.777 403.217C148.027 403.967 127.878 404.964 125.637 402.466C123.396 399.968 124.393 393.009 122.152 390.027C119.911 387.046 116.18 387.036 116.18 382.307C116.18 377.579 120.908 375.584 120.908 375.584L119.665 356.669L133.851 356.423Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M144.346 399.732C143.715 399.21 143.133 398.632 142.608 398.005C139.853 399.033 136.872 399.701 134.631 398.981C129.162 397.244 124.927 393.759 123.683 386.789C122.912 382.451 119.715 379.85 117.423 378.504C116.634 379.615 116.213 380.945 116.22 382.307C116.22 387.036 119.951 387.036 122.192 390.027C124.433 393.019 123.436 399.978 125.677 402.466C127.918 404.954 148.077 403.967 148.817 403.216C149.557 402.466 145.836 400.729 144.346 399.732Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M116.962 385.545V403.967H119.203L120.693 388.537L116.962 385.545Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M124.682 278.768C124.682 278.768 141.602 280.506 141.355 291.957C141.109 303.409 140.327 357.913 140.327 357.913L117.465 360.411C117.465 360.411 112.479 332.285 113.723 320.834C114.967 309.382 116.961 307.141 116.961 307.141H79.8818C79.8818 307.141 83.6134 298.68 95.5586 289.716C107.504 280.752 124.682 278.768 124.682 278.768Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3446 219.772C87.5143 222.614 87.8576 225.443 88.3726 228.243C89.1128 231.975 93.1014 233.712 94.3452 239.191C95.5891 244.67 93.5948 247.158 93.8415 252.884C94.0882 258.61 97.5834 266.32 98.0768 269.064C98.5703 271.809 95.5891 274.04 91.3538 276.774C87.1185 279.509 50.2857 293.222 45.3103 287.722C40.3348 282.223 44.5598 274.533 43.573 268.314C42.5861 262.095 37.5901 236.95 35.3491 227.194C33.1081 217.439 31.9156 212.669 37.22 210.531C40.9516 209.04 54.2023 214.303 54.2023 214.303C54.2023 214.303 58.9414 214.797 69.139 214.797",
    fill: "#787878"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3446 219.772C87.5143 222.614 87.8576 225.443 88.3726 228.243C89.1128 231.975 93.1014 233.712 94.3452 239.191C95.5891 244.67 93.5948 247.158 93.8415 252.884C94.0882 258.61 97.5834 266.32 98.0768 269.064C98.5703 271.809 95.5891 274.04 91.3538 276.774C87.1185 279.509 50.2857 293.222 45.3103 287.722C40.3348 282.223 44.5598 274.533 43.573 268.314C42.5861 262.095 37.5901 236.95 35.3491 227.194C33.1081 217.439 31.9156 212.669 37.22 210.531C40.9516 209.04 54.2023 214.303 54.2023 214.303C54.2023 214.303 58.9414 214.797 69.139 214.797",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8042 183.865V211.466C48.8042 211.466 54.0161 215.907 60.585 221.119C67.1538 226.331 71.9751 227.287 72.9208 222.466C73.8666 217.644 69.6313 211.846 68.2846 210.5C66.9379 209.153 67.123 197.763 67.123 197.763C67.123 197.763 53.0498 182.898 50.5827 181.346C48.1155 179.794 48.8042 183.865 48.8042 183.865Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9595 152.007C77.9595 152.007 87.9926 154.711 88.2393 161.855C88.486 169 77.5688 171.703 76.4175 169.205C75.2661 166.707 73.7139 153.95 73.8989 152.213C74.0839 150.476 77.9595 152.007 77.9595 152.007Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5927 157.034C79.5927 157.034 84.2289 168.034 82.2038 177.296C80.1786 186.558 76.1181 196.982 72.9519 199.911C69.7857 202.841 66.0027 203.581 59.3413 198.174C54.5304 194.268 48.6297 186.589 47.1803 182.538C45.7308 178.488 46.8924 170.377 52.1043 162.565C57.3162 154.752 76.4162 151.236 79.5927 157.034Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3546 177.152C70.0132 177.152 70.547 176.245 70.547 175.127C70.547 174.008 70.0132 173.102 69.3546 173.102C68.696 173.102 68.1621 174.008 68.1621 175.127C68.1621 176.245 68.696 177.152 69.3546 177.152Z",
    fill: "#263238"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9431 175.312C79.9431 176.432 79.4085 177.368 78.7506 177.368C78.0927 177.368 77.5479 176.463 77.5479 175.312C77.5479 174.16 78.0824 173.256 78.7506 173.256C79.4188 173.256 79.9431 174.191 79.9431 175.312Z",
    fill: "#263238"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1025 170.707C78.1025 170.707 75.3372 173.102 76.0466 176.422C76.7559 179.743 78.1025 181.942 77.5166 183.053C76.9306 184.163 74.4326 184.153 74.4326 184.153",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6572 169.606C64.6572 169.606 69.0776 167.211 72.0279 168.311",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6582 168.681C78.6582 168.681 80.4983 167.026 82.3384 169.422",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5579 188.203C69.5964 188.203 68.6553 187.926 67.8475 187.404C67.0397 186.883 66.3996 186.139 66.0039 185.263",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4044 176.607C30.4044 176.607 53.9762 173.523 65.356 167.581C76.7358 161.639 81.0122 157.445 80.087 152.665C79.1618 147.885 67.7512 139.959 55.0452 140.134C49.6361 140.259 44.3856 141.986 39.9589 145.097C35.5321 148.208 32.1282 152.563 30.1782 157.61C27.269 165.926 30.4044 176.607 30.4044 176.607Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1435 151.319C65.9427 156.935 59.829 161.63 53.0613 165.207C46.2353 168.6 38.8842 170.814 31.3193 171.755",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5479 169.134C36.8099 167.21 42.8639 164.665 48.6199 161.537",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5479 159.183C52.5479 159.183 63.0333 151.843 68.2658 146.59",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9583 177.008C52.9583 177.008 49.1958 168.609 44.8474 171.796C40.4991 174.983 43.4083 184.245 46.0091 185.982C48.6099 187.72 52.3826 185.119 52.3826 185.119",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9583 177.008C52.9583 177.008 49.1958 168.609 44.8474 171.796C40.4991 174.983 43.4083 184.245 46.0091 185.982C48.6099 187.72 52.3826 185.119 52.3826 185.119",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5625 255.371C86.5625 255.371 96.7704 253.624 100.502 253.13C104.234 252.637 113.948 256.122 113.444 257.859C112.941 259.596 102.496 260.851 99.0525 262.094C95.6088 263.338 87.8475 261.591 87.8475 261.591L86.5625 255.371Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5565 213.799C49.5565 213.799 46.0717 208.331 37.8581 209.821C29.6444 211.312 27.1464 219.772 27.4034 228.243C27.6604 236.713 36.6553 273.793 39.8421 276.034C43.0288 278.275 88.3425 264.808 88.3425 264.808L86.5949 255.351L52.7433 257.366L49.0117 226.773",
    fill: "#787878"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5565 213.799C49.5565 213.799 46.0717 208.331 37.8581 209.821C29.6444 211.312 27.1464 219.772 27.4034 228.243C27.6604 236.713 36.6553 273.793 39.8421 276.034C43.0288 278.275 88.3425 264.808 88.3425 264.808L86.5949 255.351L52.7433 257.366L49.0117 226.773",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M113.62 255.197L77.4863 272.302L87.1288 276.394L133.368 260.254L113.62 255.197Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M141.798 268.92C141.798 268.92 139.392 260.244 133.368 260.244C127.344 260.244 88.8153 272.775 75.5645 278.069C62.3138 283.363 50.9956 286.499 48.3434 290.6C45.6912 294.702 50.5125 310.348 58.942 312.753C67.3714 315.159 82.3081 312.034 88.5685 308.642C94.829 305.249 137.706 274.924 137.706 274.924",
    fill: "#263238"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M141.798 268.92C141.798 268.92 139.392 260.244 133.368 260.244C127.344 260.244 88.8153 272.775 75.5645 278.069C62.3138 283.363 50.9956 286.499 48.3434 290.6C45.6912 294.702 50.5125 310.348 58.942 312.753C67.3714 315.159 82.3081 312.034 88.5685 308.642C94.829 305.249 137.706 274.924 137.706 274.924",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9619 268.036C15.9619 268.036 31.3817 280.125 50.2761 281.4C69.1705 282.675 77.4664 286.201 78.6691 296.645C79.8719 307.089 81.3008 336.613 81.3008 336.613L30.2921 336.932L20.2486 287.208L15.9619 268.036Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6602 281.965C27.6602 281.965 32.3889 288.277 44.2313 289.326C56.0737 290.374 64.9966 291.957 67.875 295.905",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate2);
export default __webpack_public_path__ + "static/media/Create2.9068644c345ea20990bb2fe3b96bd2b4.svg";
export { ForwardRef as ReactComponent };